import './index.module.scss';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { PartnerSOWRateCard } from '@ad/ad_utils_react/src/components/business/TTCX/AddOn/types';
import { useLoadingEffect } from '@ad/ad_utils_react/src/utils/hooks/loading';
import { checkSuccessResponse } from '@ad/ad_utils/src';
import { globalInfoStore, UserRoleEnum } from '@/models/global';
import projectApis from '@/apis/projectApis';
import TTCXPackageCard, { CardType } from '../TTCXPackageCard';
import { RevertRegionTextMap } from '../BusinessRelatedParams/consts';
import SubscriptionGeneralTerms from './SubscriptionGeneralTerms';

function PackagesPage() {
  const [t] = useTranslation();

  useEffect(() => {
    globalInfoStore.setShowHeader(false);

    return () => {
      globalInfoStore.setShowHeader(true);
    };
  }, []);

  const [packageCard, setPackageCard] = useState<PartnerSOWRateCard[]>([]);
  const [gettingPackageCard, getPackageCard] = useLoadingEffect(async () => {
    const res = await projectApis.getExhibit();
    if (checkSuccessResponse(res.code)) {
      const exhibit = Object.values(res.data.exhibitA);
      setPackageCard(exhibit as PartnerSOWRateCard[]);
    }
  });

  useEffect(() => {
    (async () => {
      await getPackageCard();
    })();
  }, []);

  return (
    <div className="rate-card-page">
      <h1>{t('exhibit_a', 'Exhibit A')}</h1>
      <SubscriptionGeneralTerms />
      <br />
      <br />
      <br />
      <div className="rate-cards">
        <h2>{t('ttcx_packages', 'TTCX Packages')}</h2>
        {packageCard.map((item) => {
          return (
            <div className="rate-card-item" key={item.region}>
              <TTCXPackageCard
                cardType={CardType.ttcxPackage}
                region={RevertRegionTextMap[item.region]}
                card={item}
                userRole={UserRoleEnum.Advertiser}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default observer(PackagesPage);
